import React, {Component} from 'react';
import userImage from '../../../assets/img/128x128.jpg';
import moment from 'moment';

/* global $ */
class Flags extends Component {
    componentDidMount(){
        if(this.props.match.params.courseUserId){
            this.props.loadCourseUserFlags(this.props.match.params.courseUserId, this.props.user.id);
        }else if(this.props.courseUser[0].id){
            this.props.loadFlags(this.props.courseUser[0], this.props.user.id);
        }else{

        }
        
    }

    showFlagDetails = (e) => {
        let btn = e.target;
        var t = $(btn).text();
          if(t=="Show Details"){
            $(btn).text("Hide Details");
          }else{
            $(btn).text("Show Details");
          }
          $(btn).parents("td").find(".redflagdetails").stop().slideToggle();
    }
    render(){
        let {flags} = this.props;

        return (
            <div id="content-container" className="content-wrapper">
                <section className="content">
                    <div className="panel customPanel">
                    <div className="panel-body no-padding darkest-panel" style={{ background: "#181818 !important" }}>

                    <div className="sp-20">
                        <div className="clearfix">
                            <div className="RFH">
                                <div>
                                    <p className="font-24 text-white sm-bottom30">Red Flags</p>
                                </div>
                                <div>
                                    <div className="legends">
                                        <div className="legendItem">
                                            <div className="flagIconLegend "> <i className="zmdi zmdi-flag"></i> {flags.filter(f => f.type === 'red').length}</div>
                                        </div>
                                        <div className="legendItem">
                                            <div className="flagIconLegend "> <i className="zmdi zmdi-flag orange-flag"></i> {flags.filter(f => f.type === 'orange').length}</div>
                                        </div>
                                        <div className="legendItem">
                                            <div className="flagIconLegend "> <i className="zmdi zmdi-flag yellow-flag"></i> {flags.filter(f => f.type === 'yellow').length}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        
                        {flags.length === 0 ?
                            <div className="empty-alerts text-green">
                                        <i className="zmdi zmdi-check zmdi-lg" />
                                        <h4>Nothing to worry about!</h4>
                                    </div>
                            :

                        <table className="table" style={{background: "#181818"}}>
                            <tbody>
                            <tr>
                                <th style={{width: "90px"}}>Warning Type</th>
                                <th>Description</th>
                                <th style={{width: "190px"}}><i className="zmdi zmdi-calendar font-24"></i></th>
                            </tr>
                            {flags.length > 0 ?
                                    flags.map(f => {
                                        return (
                                            <tr>
                                                <td className="text-center">
                                                    <div className="th-wrapper" data-toggle="popover" data-trigger="hover" title="Popover title" data-content="And here's some amazing content. It's very engaging. Right?">
                                                        {f.type == 'red' &&
                                                            <div className="flagIcon  ">
                                                                <i className="zmdi zmdi-flag"></i>
                                                            </div>
                                                            }
                                                            
                                                            {f.type == 'orange' &&
                                                                <div className="flagIcon  orange-flag">
                                                                    <i className="zmdi zmdi-flag"></i>
            
                                                                </div>
                                                            }
                                                            
                                                            {f.type == 'yellow' &&
                                                                <div className="flagIcon  yellow-flag">
                                                                    <i className="zmdi zmdi-alert-triangle"></i>
            
                                                                </div>
                                                            }
                                                        
                                                    </div>
                                                </td>
                                                <td style={{verticalAlign: "middle"}}>
                                                    <div className="flex space-between text-left">
                                                        <div className="font-14">
                                                            <p className="hoverable-text">{f.content}</p>
                                                            <p className="sm-top10"><a href="#" onClick={e => this.showFlagDetails(e)} className="font-12 text-muted">Show Details</a> </p>
                                                        </div>
                                                    </div>
                                                    <div className="redflagdetails font-300">
                                                        <h3 className="font-30 font-300 sm-top0" dangerouslySetInnerHTML={{__html: f.summary}}></h3>
                                                        
                                                        <p>{f.details}</p>
                                                    </div>
                                                </td>
                                                <td style={{verticalAlign: "middle"}}>{moment(f.createdOn).format('YYYY-MM-DD')}</td>
                                            </tr>      
                                        )
                                    })
                                    :
                                    null
                                }
                            </tbody>
                        </table>
                        }
                    </div>
                        </div>
                        </div>

                    
                </section>
            </div>
        )
    }
}

export default Flags;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/Flags.js